import script from "./PromptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptModal.vue?vue&type=script&setup=true&lang=js"

import "./PromptModal.vue?vue&type=style&index=0&id=0be2fc03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be2fc03"]])

export default __exports__